export const orBlock =
  typeof window !== 'undefined' ? document.createElement('span') : {};
orBlock.className = 'or-block';
